var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import { Dependencies } from "~/core/decorator";
import { Emit, Prop } from "vue-property-decorator";
import DataBox from "~/components/common/data-box.vue";
import { SmartCollectionService } from "~/services/domain-service/smart-collection.service";
import { TemplateService } from "~/services/domain-service/template.service";
var MailSendList = /** @class */ (function (_super) {
    __extends(MailSendList, _super);
    function MailSendList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.dataSet = [];
        _this.templateSet = [];
        _this.model = {
            overduePeriod: "",
            templateId: "",
            messageContent: ""
        };
        return _this;
    }
    MailSendList.prototype.refreshData = function () {
        var form = this.$refs["form"];
        form.resetFields();
        this.loadingData();
    };
    MailSendList.prototype.close = function () { };
    MailSendList.prototype.loadingData = function () {
        var _this = this;
        var request = {
            ids: this.selectionList.map(function (v) { return v.id; })
        };
        this.smartCollectionService
            .getMailPersonal(request)
            .subscribe(function (data) { return (_this.dataSet = data || []); });
    };
    /**
     * 逾期阶段改变
     */
    MailSendList.prototype.onOverduePeriodChange = function (overduePeriod) {
        var _this = this;
        if (overduePeriod) {
            this.templateService
                .getTemplateByOverduePeriod({ overduePeriod: overduePeriod, templateCategory: "MAIL" })
                .subscribe(function (data) { return (_this.templateSet = data || []); });
        }
        else {
            this.model.overduePeriod = "";
        }
        this.onTemplateChange("");
    };
    /**
     * 模板改变
     */
    MailSendList.prototype.onTemplateChange = function (templateId) {
        var templateContent = "";
        if (templateId) {
            var template = this.templateSet.find(function (v) { return v.id === templateId; });
            templateContent = template.templateContent;
        }
        this.model.templateId = templateId;
        this.model.messageContent = templateContent;
    };
    /**
     * 发送
     */
    MailSendList.prototype.submit = function () {
        var _this = this;
        if (this.dataSet.length === 0) {
            this.$message.warning("数据为空,不能发送");
            return;
        }
        var form = this.$refs["form"];
        form.validate(function (v) {
            if (!v)
                return;
            var sendMessage = _this.dataSet.map(function (v) {
                return {
                    caseId: v.caseId,
                    contId: v.id
                };
            });
            var request = {
                templateId: _this.model.templateId,
                sendMessageRequests: sendMessage
            };
            _this.smartCollectionService.batchSendMail(request).subscribe(function (data) {
                _this.close();
                _this.$message.success("发送成功");
            });
        });
    };
    /**
     * 移除邮箱
     */
    MailSendList.prototype.removeMail = function (scope) {
        var index = scope.$index;
        this.dataSet.splice(index, 1);
    };
    __decorate([
        Dependencies(SmartCollectionService)
    ], MailSendList.prototype, "smartCollectionService", void 0);
    __decorate([
        Dependencies(TemplateService)
    ], MailSendList.prototype, "templateService", void 0);
    __decorate([
        Prop()
    ], MailSendList.prototype, "selectionList", void 0);
    __decorate([
        Emit("close")
    ], MailSendList.prototype, "close", null);
    MailSendList = __decorate([
        Component({
            components: {
                DataBox: DataBox
            }
        })
    ], MailSendList);
    return MailSendList;
}(Vue));
export default MailSendList;
